import { router } from 'expo-router';
import { useAtom } from 'jotai';
import * as React from 'react';
import { useState } from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    RadioInputRow,
    ScreenContainer,
    YStack,
} from 'smoothie';

import { RetirementDistributionCreateType } from '../../hooks/useTestICTWithdrawal';
import { apexWithdrawalRequestAtom } from '../../state/investmentAtoms';

export const WithdrawalReason = () => {
    const [apexWithdrawalRequest, setApexWithdrawalRequest] = useAtom(
        apexWithdrawalRequestAtom,
    );

    const [distributionType, setDistributionType] =
        useState<RetirementDistributionCreateType>(
            RetirementDistributionCreateType.PREMATURE,
        );

    return (
        <ScreenContainer
            onFallbackRoute="/home/investment"
            hasBackButton={true}
            title="Review"
        >
            <YStack gap={24}>
                <BodyMediumRegular>
                    The IRS requires that we ask the reason for this withdrawal.
                    Please ask your tax professional if you’re not sure which
                    option is best for you.
                </BodyMediumRegular>
                <RadioInputRow
                    isSelected={
                        distributionType ===
                        RetirementDistributionCreateType.PREMATURE
                    }
                    onPress={() => {
                        setDistributionType(
                            RetirementDistributionCreateType.PREMATURE,
                        );
                    }}
                    label="Premature distribution"
                    details="Since I am not yet 59.5 years old and I understand that taxes and early withdrawal penalties may be assessed by the IRS."
                />
                <RadioInputRow
                    isSelected={
                        distributionType ===
                        RetirementDistributionCreateType.EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE
                    }
                    onPress={() => {
                        setDistributionType(
                            RetirementDistributionCreateType.EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE,
                        );
                    }}
                    label="Removing excess contribution before tax deadline"
                    details="To keep total contributions for the year less than the maximum allowed, based on my age and adjusted gross income."
                />
                <RadioInputRow
                    isSelected={
                        distributionType ===
                        RetirementDistributionCreateType.EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE
                    }
                    onPress={() => {
                        setDistributionType(
                            RetirementDistributionCreateType.EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE,
                        );
                    }}
                    label="Removing excess contribution after tax deadline"
                    details="To keep total contributions for the year less than the maximum allowed, based on my age and adjusted gross income."
                />
                <Button
                    disabled={false}
                    text="Continue"
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    onPress={() => {
                        setApexWithdrawalRequest({
                            ...apexWithdrawalRequest,
                            distributionType,
                        });
                        router.navigate(
                            '/investments/transfer/withdrawal-review',
                        );
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
};
